import { Breadcrumb, Button, Card, Col, Dropdown, Flex, Modal, Row, Space, Tabs } from "antd";
import FormItem from "antd/es/form/FormItem";
import { FormDatePicker, FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import TableAntd from "components/elements/Table";
import { DownloadOutlined, EyeOutlined, MailOutlined, MoreOutlined } from "@ant-design/icons";
import dayjs from 'dayjs';
import ReportStatus from "../ReportStatus";
import Section50BisModal from "../reportModal/Section50BisModal";
import SendMail50BisModal from "../reportModal/SendMail50BisModal";
import { useCallback } from "react";
function formatDate({ dateString, pattern = "YYYY-MM-DD", reFormat = "DD-MM-YYYY" }) {
    if (!dateString) return;
    const date = dayjs(dateString, pattern);
    return date.format(reFormat);
}
const Section50BisReportComponent = ({
    showReport,
    pagination,
    pagination2,
    isModalOpen = false,
    reportSection50BisTable = [],
    reportSection50BisTable2 = [],
    employmentTypeOptions = [],
    employeeStatusTypeOptions = [],
    setIsModalOpen = () => { },
    handleSearch = () => { },
    showModal = () => { },
    onChange = () => { },
    setYear = () => { },
    exportSection50BisReportReportPdf = () => { },
    sendSection50BisReportReportPdf = () => { },
    exportSection50BisReportReportPdfExtra = () => { },
    sendSection50BisReportReportPdfExtra = () => { },
    confirmModalFn = () => { },
    search = {},
    isSendMailModalOpen = false,
    setIsSendMailModalOpen = () => { },
    handleSendEmail = () => { },
    selectedRecord = {},
    mode = "",
    setMode = () => { },
}) => {
    const { t, i18n } = useTranslation();

    const columns = [
        {
            title: <div className="text-table">{t('report.employeeNo')}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            align: "center",
            width: 180,
            render: (_, record) => {
                if (record?.employeeNo === null || record?.employeeNo === undefined || record?.employeeNo === "") {
                    return "-";
                }
                return <span
                    style={{
                        color: "#42526D",
                        backgroundColor: "#F5F6F7",
                        borderRadius: "20px",
                        width: "max-content",
                        height: "30px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        margin: "auto",
                        padding: "8px 16px"
                    }}
                >
                    {record?.employeeNo}
                </span>;
            },
        },
        {
            title: <div className="text-table">{t('employee.label.name')}</div>,
            dataIndex: "name",
            key: "name",
            align: "left",
            width: 250,
            render: (_, record) => {
                return (record?.name ?
                    (i18n.language === "en" ? record?.nameEn + " " + record?.surNameEn : record?.name + " " + record?.surName) : "-"
                )
            },
        },
        {
            title: <div className="text-table">{t('department')}</div>,
            dataIndex: "department",
            key: "department",
            align: "left",
            width: 250,
            render: (_, record) => {
                return (
                    record?.department?.departmentId ? (i18n.language === "en" ? record?.department?.organizationNameEn : record?.department?.organizationName) : "-"
                )
            },
        },
        {
            title: <div className="text-table">{t('report.position')}</div>,
            dataIndex: "position",
            key: "position",
            align: "left",
            width: 300,
            render: (_, record) => {
                return (
                    record?.position?.positionId ? (i18n.language === "en" ? record?.position?.positionNameEn : record?.position?.positionName) : "-"
                )
            },
        },
        {
            title: <div className="text-table">{t('employment-type')}</div>,
            dataIndex: "employmentType",
            key: "employmentType",
            width: 200,
            align: "left",
            render: (_, record) => {
                return (
                    record?.employmentType?.employeeTypeId ? (i18n.language === "en" ? record?.employmentType?.nameEn : record?.employmentType?.name) : "-"
                )
            },
        },
        {
            title: <div className="text-table">{t('report.payroll_period')}</div>,
            dataIndex: "period",
            key: "period",
            width: 200,
            align: "left",
            render: (_, record) => {
                console.log("record.month", record.month, dayjs(String(record.month).padStart(2, '0'), "MM").format("MMMM"));
                return (
                    record?.period ? (i18n.language === "en" ? `${dayjs(String(record.month).padStart(2, '0'), "MM").format("MMMM")} (${record?.period})(Period No ${record?.period})` : `${dayjs(String(record.month).padStart(2, '0'), "MM").format("MMMM")} (งวดที่ ${record?.period})`) : "-"
                )
            },
        },
        {
            title: <div className="text-table">{t('stauts')}</div>,
            dataIndex: "employeeStatus",
            key: "employeeStatus",
            align: "center",
            width: 200,
            render: (_, record) => {
                if (record?.employeeStatus) {
                    if (i18n.language === "en") {
                        return <ReportStatus value={record?.employeeStatus?.nameEn} />;
                    }
                    return <ReportStatus value={record?.employeeStatus?.name} />;
                }
                return "-"
            },
        },
        {
            title: <div className="text-table">{t('payment.label.emailSend')}</div>,
            dataIndex: "sendThawi50Status",
            key: "sendThawi50Status",
            align: "center",
            width: 200,
            render: (_, record) => {
                if (record?.sendThawi50Status) {
                    return <Space direction='vertical'>
                        {sendStatus(record?.sendThawi50Status)}
                        {formatDate({ dateString: record?.sendThawi50Date, reFormat: i18n.language === "en" ? "DD MMM YYYY" : "DD MMMM BBBB" })}
                    </Space>
                }
                return "-"
            },
        },
        {
            title: "",
            key: "action",
            align: "center",
            width: 100,
            render: (_, record) => (
                <Space size="middle">
                    <Dropdown
                        placement="bottomRight"
                        menu={{
                            items: [
                                {
                                    key: "1",
                                    label: (
                                        <p
                                            style={{ color: "grey", fontSize: "14px" }}
                                            onClick={() => mode == "M01" ? exportSection50BisReportReportPdf(record) : mode == "M02" ? exportSection50BisReportReportPdfExtra(record) : () => { }}
                                        >
                                            {t("action.download")}
                                        </p>
                                    ),
                                    icon: (
                                        <DownloadOutlined
                                            style={{ fontSize: "18px", color: "gray" }}
                                            onClick={() => mode == "M01" ? exportSection50BisReportReportPdf(record) : mode == "M02" ? exportSection50BisReportReportPdfExtra(record) : () => { }}
                                        />
                                    ),
                                },
                                {
                                    key: "2",
                                    onClick: (() => handleSendEmail(record)),
                                    label: (
                                        <p style={{ color: "grey", fontSize: "14px" }}>
                                            {t("action.sende_email_50_bis")}
                                        </p>
                                    ),
                                    icon: (
                                        <MailOutlined style={{ fontSize: "18px", color: "gray" }} />
                                    ),
                                },
                            ],
                        }}
                    >
                        <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
                    </Dropdown>
                </Space >
            ),
        }
    ]

    function sendStatus(params) {
        switch (params) {
            case "SEND":
                return i18n.language === 'en' ? params : "ส่งแล้ว"
            case "INPROGRESS":
                return i18n.language === 'en' ? params : "กำลังดำเนินการ"
            case "REJECT":
                return i18n.language === 'en' ? params : "ส่งไม่สำเร็จ"
            default:
                return "-"
        }
    }

    const tableRender = useCallback(
        () => {
            console.log("mode", mode);

            if (mode == "M01") {
                return <TableAntd
                    columns={columns}
                    dataSource={reportSection50BisTable}
                    rowKey={(record) => record.id}
                    onChange={onChange}
                    pagination={pagination}
                />
            } else
                if (mode == "M02") {
                    return <TableAntd
                        columns={columns}
                        dataSource={reportSection50BisTable2}
                        rowKey={(record) => record.id}
                        onChange={onChange}
                        pagination={pagination2}
                    />
                }
        },
        [mode, reportSection50BisTable, reportSection50BisTable2, pagination, pagination2],
    )
    console.log("reportSection50BisTable", reportSection50BisTable, reportSection50BisTable2);


    return (
        <MainLayout>
            <Section50BisModal
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                exportSection50BisReportReportPdf={mode == "M01" ? exportSection50BisReportReportPdf : mode == "M02" ? exportSection50BisReportReportPdfExtra : () => { }}
            />

            <SendMail50BisModal
                isSendMailModalOpen={isSendMailModalOpen}
                setIsSendMailModalOpen={setIsSendMailModalOpen}
                selectedRecord={selectedRecord}
                sendSection50BisReportReportPdf={mode == "M01" ? sendSection50BisReportReportPdf : mode == "M02" ? sendSection50BisReportReportPdfExtra : () => { }}
            />

            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), href: "/" },
                        { title: t("report.header"), href: "" },
                        { title: t("salary_calculation_group.header"), href: "" },
                        { title: t("section_50bis_report.header") }
                    ]} />
                    <h2>{t("section_50bis_report.header")}</h2>
                </Flex>

                <FormAntd
                    onFinish={handleSearch}
                    initialValues={{ year: dayjs() }}
                >
                    <FormItem shouldUpdate={(prev, curv) => {
                        return false
                    }}>
                        {({ getFieldValue, setFieldValue, resetFields }) => {
                            return (
                                <>
                                    <Card style={{
                                        backgroundColor: "white",
                                        width: "100%",
                                        marginBottom: "1vw",
                                        border: "1px solid #EAECF0",
                                    }}>
                                        <Flex vertical style={{ rowGap: "24px" }}>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeNo"
                                                        label={t("employee.label.employee_no")}
                                                        size="large"
                                                    />
                                                </Col>

                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeFullName"
                                                        label={t("name-surname")}
                                                        size="large"
                                                    />
                                                </Col>

                                                <Col span={8}>
                                                    <FormDatePicker
                                                        name="year"
                                                        dateFormat={"YYYY"}
                                                        picker="year"
                                                        label={t('payroll_period.label.tax_year')}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('report.all')}
                                                        size="large"
                                                        onChange={(value, info) => {
                                                            console.log("log onChange", value, value?.year?.(), info);

                                                            setFieldValue("year", value);
                                                            setYear(value?.year?.())
                                                        }}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="employmentTypeId"
                                                        label={t("salary.label.employment_type")}
                                                        size="large"
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('report.please_select')}
                                                        options={employmentTypeOptions}
                                                        mode="multiple"
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="employeeStatusId"
                                                        label={t('employee.label.employee_status')}
                                                        options={employeeStatusTypeOptions}
                                                        allowClear
                                                        style={{ width: '100%', }}
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        mode="multiple"
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormDatePicker
                                                        name="month"
                                                        dateFormat={"MMMM"}
                                                        picker="month"
                                                        label={t('month')}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('month')}
                                                        size="large"
                                                        onChange={(value, info) => {
                                                            console.log("log onChange", value, info);

                                                            setFieldValue("month", value);
                                                            // setMonth(value?.year?.())
                                                        }}
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="statusEmail"
                                                        label={t('payment.label.emailSend')}
                                                        options={[
                                                            { label: "ทั้งหมด", value: null },
                                                            { label: "ส่งแล้ว", value: "SEND" },
                                                            { label: "ส่งไม่สำเร็จ", value: "REJECT" }
                                                        ]}
                                                        allowClear
                                                        style={{ width: '100%', }}
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        sortBy="value"
                                                    />
                                                </Col>
                                            </Row>
                                            <Row gutter={[24, 16]} style={{ justifyContent: "end", display: "flex", gap: "16px" }}>
                                                <Button type="default" onClick={() => {
                                                    resetFields()
                                                    setMode("M01")
                                                    setYear(dayjs()?.year?.())
                                                }} style={{ borderRadius: "8px", height: "40px" }}>
                                                    {t("common.clear").toUpperCase()}
                                                </Button>
                                                <Button type="primary" htmlType="submit" style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color)", boxShadow: "none" }}>
                                                    {t("creatTamplete.Search").toUpperCase()}
                                                </Button>
                                            </Row>
                                        </Flex>
                                    </Card>

                                    {(
                                        <Space direction="vertical" size={16} style={{ width: "100%" }}>
                                            <Card style={{
                                                backgroundColor: "white",
                                                width: "100%",
                                                border: "1px solid #EAECF0",
                                            }}>
                                                <Tabs
                                                    destroyInactiveTabPane
                                                    defaultActiveKey="M01"
                                                    onChange={(e) => {
                                                        console.log("e", e);
                                                        setMode(e)
                                                    }}
                                                >
                                                    <Tabs.TabPane
                                                        tab={t('pdng1')}
                                                        key="M01"
                                                    >
                                                        <Space direction="vertical" size={8} style={{ width: "100%" }}>
                                                            {showReport && <span style={{ fontSize: "1vw", fontWeight: "bold" }}>{t('pdng1')}<Button style={{ float: "right" }} onClick={confirmModalFn}>{t('section_50bis_report.all')}</Button><Button style={{ float: "right" }} onClick={() => confirmModalFn(1)}>{t('download.50thawi')}</Button></span>}
                                                            {tableRender()}
                                                        </Space>

                                                    </Tabs.TabPane>

                                                    <Tabs.TabPane
                                                        tab={t('pdng3')}
                                                        key="M02"
                                                    >
                                                        <Space direction="vertical" size={8} style={{ width: "100%" }}>
                                                            {showReport && <span style={{ fontSize: "1vw", fontWeight: "bold" }}>{t('pdng3')} <Button style={{ float: "right" }} onClick={confirmModalFn}>{t('section_50bis_report.all')}</Button><Button style={{ float: "right" }} onClick={() => confirmModalFn(1)}>{t('download.50thawi')}</Button></span>}
                                                            {tableRender()}
                                                        </Space>
                                                    </Tabs.TabPane>
                                                </Tabs>

                                                {/* <TableAntd
                                                        columns={columns}
                                                        dataSource={reportSection50BisTable}
                                                        rowKey={(record) => record.id}
                                                        onChange={onChange}
                                                        pagination={pagination}
                                                    /> */}

                                            </Card>
                                        </Space >
                                    )}
                                </>
                            )
                        }}
                    </FormItem>
                </FormAntd>
            </Space>
        </MainLayout >
    )
}

export default Section50BisReportComponent;